import React from 'react';
import useImport from '../hooks/useImport';
import ImportStatusAlert from '../components/ImportStatusAlert';
import ImportTypeSelector from '../components/ImportTypeSelector';
import ImportHistory from '../components/ImportHistory';
import ConfirmImportModal from '../components/ConfirmImportModal';

const MANDATORY_TYPES = ['obras'];

/**
 * Card completo de importação MaisControle.
 * Compõe todos os componentes reutilizáveis + hook de importação.
 */
const MaisControleImport = () => {
  const {
    isLoading,
    hasProcessing,
    isPosting,
    isButtonDisabled,
    currentImport,
    reports,
    availableTypes,
    selectedTypes,
    showConfirmModal,
    handleToggleType,
    handleSelectAll,
    handleDeselectOptionals,
    handleOpenConfirmModal,
    handleConfirmImport,
    setShowConfirmModal,
    getTypeLabel,
  } = useImport({
    baseEndpoint: 'gci/imports',
    mandatoryTypes: MANDATORY_TYPES,
  });

  return (
    <>
      {/* Card principal */}
      <div className="card card-outline card-info">
        <div className="card-header">
          <h3 className="card-title">
            <i className="fa-solid fa-database mr-1"></i>
            Importações MaisControle
          </h3>
        </div>

        <div className="card-body">
          {isLoading && <p>Carregando...</p>}

          {!isLoading && (
            <>
              {/* Importação em andamento */}
              {(hasProcessing || isPosting) && (
                <ImportStatusAlert
                  currentImport={currentImport}
                  getTypeLabel={getTypeLabel}
                />
              )}

              {/* Seleção de tipos */}
              <ImportTypeSelector
                availableTypes={availableTypes}
                selectedTypes={selectedTypes}
                mandatoryTypes={MANDATORY_TYPES}
                disabled={isButtonDisabled}
                onToggleType={handleToggleType}
                onSelectAll={handleSelectAll}
                onDeselectOptionals={handleDeselectOptionals}
              />

              {/* Botão de importar */}
              <div className="mb-3">
                <button
                  className="btn btn-primary"
                  onClick={handleOpenConfirmModal}
                  disabled={isButtonDisabled}
                >
                  <i
                    className={`mr-1 ${
                      isButtonDisabled
                        ? 'fa-solid fa-spinner fa-spin'
                        : 'fa-solid fa-cloud-arrow-down'
                    }`}
                  ></i>
                  {isButtonDisabled
                    ? 'Importação em Andamento...'
                    : 'Importar Selecionados'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Modal de confirmação */}
      <ConfirmImportModal
        show={showConfirmModal}
        selectedTypes={selectedTypes}
        getTypeLabel={getTypeLabel}
        onConfirm={handleConfirmImport}
        onCancel={() => setShowConfirmModal(false)}
      />

      {/* Histórico */}
      {!isLoading && (
        <ImportHistory
          reports={reports}
          getTypeLabel={getTypeLabel}
        />
      )}
    </>
  );
};

export default MaisControleImport;
